import React from "react";
import getSchoolFieldSelector from "../../../../state/selectors/SchoolSelectors/getSchoolFieldSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const SchoolRows: React.FC = () => {
    const freeFields = useSelector((state: Store) => getSchoolFieldSelector(state, "freeFields"));
    if (!freeFields) return null;
    return freeFields.map((freeField: { title: string; content: string }, i: number) => (
        <FlexWrapper key={`freeField-${i}`}>
            <Left>{freeField.title}</Left>
            <Right dangerouslySetInnerHTML={{ __html: freeField.content }} />
        </FlexWrapper>
    ));
};

export default SchoolRows;

const FlexWrapper = styled.div`
    display: flex;
    padding-bottom: 2rem;
`;

const Left = styled.div`
    width: 23%;
    font-weight: 700;
    font-size: 1.1rem;
    padding: 0 0.5rem;
    @media print {
        font-size: 1rem;
    }
`;

const Right = styled.div`
    flex: 1;
    font-size: 1.1rem;
    padding: 0 0.5rem;
    @media print {
        font-size: 1rem;
    }
    p {
        margin-bottom: 0.5rem;
    }
    textarea {
        font-weight: 100;
        padding: 0.5rem;
    }
`;
